import { render, staticRenderFns } from "./iconUserPlain.vue?vue&type=template&id=328f4ee4"
import script from "./iconUserPlain.vue?vue&type=script&lang=js"
export * from "./iconUserPlain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports